import { __spreadArray, __read } from '../../../node_modules/tslib/tslib.es6.js';
import localStorageAdapter from '../BrowserStorage/LocalStorageAdapter.js';
import api from '../../../node_modules/js-cookie/dist/js.cookie.mjs.js';
import { useEffect } from 'react';

var keyStorage = 'feature_attribution';
var storage = localStorageAdapter(keyStorage);
function matchesSelector(element, selector) {
    if (element.closest) {
        return element.closest(selector);
    }
    var matches = element.matches ||
        element.matchesSelector ||
        element.mozMatchesSelector ||
        element.msMatchesSelector ||
        element.oMatchesSelector ||
        element.webkitMatchesSelector;
    if (matches) {
        if (matches.apply(element, [selector])) {
            return element;
        }
        if (element.parentElement) {
            return matchesSelector(element.parentElement, selector);
        }
        return null;
    }
    return null;
}
function add(config) {
    // @ts-ignore
    if (!window.featureAttributionEnabled)
        return;
    var _a = config.limit, limit = _a === void 0 ? 5 : _a;
    var matched;
    if ('element' in config) {
        matched = matchesSelector(config.element, '[data-feature]');
        if (!matched)
            return;
    }
    var featureAttributions;
    var ahoyVisit = api.get('ahoy_visit');
    if (!ahoyVisit) {
        storage.setItem(keyStorage, JSON.stringify([]));
        sessionStorage.setItem('is_ft_temporary_valid', 'true');
    }
    if (ahoyVisit && ahoyVisit !== localStorage.getItem('cache_ahoy_visit')) {
        if (sessionStorage.getItem('is_ft_temporary_valid') !== 'true') {
            storage.setItem(keyStorage, JSON.stringify([]));
        }
        sessionStorage.removeItem('is_ft_temporary_valid');
        localStorage.setItem('cache_ahoy_visit', ahoyVisit);
    }
    try {
        featureAttributions = JSON.parse(storage.getItem(keyStorage)) || [];
    }
    catch (e) {
        featureAttributions = [];
    }
    var dataFeatureValue = ('element' in config && matched.attributes['data-feature'].value) ||
        ('data' in config && config.data);
    if (dataFeatureValue === featureAttributions[0]) {
        return;
    }
    if (limit && featureAttributions.length >= limit) {
        featureAttributions = __spreadArray([], __read(featureAttributions.slice(0, limit - 1)));
    }
    featureAttributions.splice(0, 0, dataFeatureValue);
    storage.setItem(keyStorage, JSON.stringify(featureAttributions));
}
var FeatureAttribution = {
    add: add,
};
function useClickFeatureAttribution(options) {
    var limit = (options || {}).limit;
    useEffect(function () {
        if (window.featureAttributionListenerBind)
            return;
        window.featureAttributionListenerBind = true;
        function onClick(e) {
            FeatureAttribution.add({
                element: e.target,
                limit: limit,
            });
        }
        document.body.addEventListener('click', onClick);
        return function () {
            window.featureAttributionListenerBind = false;
            document.body.removeEventListener('click', onClick);
        };
    }, []);
}

export default FeatureAttribution;
export { matchesSelector, useClickFeatureAttribution };
